import type { SectionWithCheckoutProducts } from "../../hooks/use-items-with-checkout";
import { FeedGrid } from "./FeedGrid";

export interface FeedSectionProps {
  section: SectionWithCheckoutProducts;
}

export function FeedSection({ section }: FeedSectionProps) {
  return (
    <div
      className="lookbook--feed--section"
      data-id={section.id}
      data-type="section">
      {section.title.length || section.description.length ? (
        <div className="lookbook--feed--section--info">
          {section.title.length ? (
            <h3
              className="lookbook--feed--section--title"
              data-test-id="section-title">
              {section.title}
            </h3>
          ) : null}
          {section.description.length ? (
            <p
              className="lookbook--feed--section--description"
              data-test-id="section-description">
              {section.description}
            </p>
          ) : null}
        </div>
      ) : null}
      {section.items.length ? <FeedGrid items={section.items} /> : null}
    </div>
  );
}
